import { RECLIST_ID_SEP } from '../../utilities/constant';
import { EMEFieldsName } from "../core/reducers/emeFieldsMapping";

export const EME_FIELDS = {
    SubscriberNameEng           : EMEFieldsName.enName,
    SubscriberNameChi           : EMEFieldsName.chName,
    IdNo                        : EMEFieldsName.idNo,
    CorrAddress                 : EMEFieldsName.postalAddress,
    ContactTel                  : EMEFieldsName.mobileNumber,
    ContactPerson               : EMEFieldsName.fullName,
    AlterEmail                  : EMEFieldsName.emailAddress,
    AlterSMS                    : EMEFieldsName.mobileNumber,
};

export const DeliveryMethod = {
    ONLINE: "DeliveryMethod3",
    POST_OR_COURIER: "DeliveryMethod1",
    BY_OWNER: "DeliveryMethod2",
    BY_AUTHORIZED_REP: "DeliveryMethod4",
};

export const SubscriberType = {
    NEW_SUBSCRIBER: "New Applicant / 新申請人",
    EXISTING_SUBSCRIBER: "Current Subscriber / 現有用戶",
};

export const PropertyType = {
    BUILD: 'Build',
    LOT: 'Lot'
};

export const SelectAddressInfo = {
    BuildingFieldId:        "Build_Add4Line",
    StreetNameFieldId:      "Build_Add3Line",
    StreetNumberFieldId:    "Build_Add2Line",
    BlockFieldId:           "Build_Blk",
    DistrictFieldId:        "Build_District",
};

export const SuppSheet_SelectAddressInfo = (idx)=>{return{
    BuildingFieldId:        "AI_" + SelectAddressInfo.BuildingFieldId + RECLIST_ID_SEP + idx,
    StreetNameFieldId:      "AI_" + SelectAddressInfo.StreetNameFieldId + RECLIST_ID_SEP + idx,
    StreetNumberFieldId:    "AI_" + SelectAddressInfo.StreetNumberFieldId + RECLIST_ID_SEP + idx,
    BlockFieldId:           "AI_" + SelectAddressInfo.BlockFieldId + RECLIST_ID_SEP + idx,
    DistrictFieldId:        "AI_" + SelectAddressInfo.DistrictFieldId + RECLIST_ID_SEP + idx,
}
};

export const LREAL1_CODE = 'LREAL1';


export const ID = {
    // Part1
    DeliveryMethod:         "DeliveryMethod",
    DeliveryMethod_list:    "DeliveryMethod_list", // Dropdown
    OrgRepresentative:      "OrgRepresentative",
    RepresentativeIdDoc:    "RepresentativeIdDoc",
    RepresentativeIdDoc_list:   "RepresentativeIdDoc_list", // Dropdown
    RepresentativeIdType_HKID:  "RepresentativeIdType_HKID",
    RepresentativeIdType_Other: "RepresentativeIdType_Other",

    RepresentativeIdNo:     "RepresentativeIdNo",
    RepresentativeAddress:  "RepresentativeAddress",

    // Part2
    SubscriberNameEng:      "SubscriberNameEng",
    SubscriberNameChi:      "SubscriberNameChi",
    SubscriberType:         "SubscriberType",
    SubscriberType_list:    "SubscriberType_list", // Dropdown
    SubscriberType_New:     "SubscriberType_New",
    SubscriberType_Curr:    "SubscriberType_Curr",

    AccountNo:              "AccountNo",
    AccountNo1:             "AccountNo1",
    AccountNo2:             "AccountNo2",
    IdDoc:                  "IdDoc",
    IdDoc_list:             "IdDoc_list", // Dropdown
    IdType_HKID:            "IdType_HKID",
    IdType_CR:              "IdType_CR",
    IdType_Other:           "IdType_Other",
    IdDocOther:             "IdDocOther",

    IdNo:                   "IdNo",
    OwnerType:              "OwnerType",
    OwnerType_list:         "OwnerType_list", // Dropdown
    OwnerType_Individual:   "OwnerType_Individual",
    OwnerType_Corporate:    "OwnerType_Corporate",

    OtherIdDoc:             "OtherIdDoc",
    AuthorizedName:         "AuthorizedName",
    CorrAddress:            "CorrAddress",
    ContactTel:             "ContactTel",
    ContactPerson:          "ContactPerson",

    // Part3
    SubscriptionFee:        "SubscriptionFee",
    SubscriptionFee0_list:  "SubscriptionFee0_list", // Dropdown
    SubscriptionFee_list:   "SubscriptionFee_list", // Dropdown

    SubscriptionFee_OneOff: "SubscriptionFee_OneOff",
    SubscriptionFee_New24:  "SubscriptionFee_New24",
    SubscriptionFee_Renew24:"SubscriptionFee_Renew24",

    OrderNo:                "OrderNo",
    VeriCode:               "VeriCode",
    ProvideRelation:        "ProvideRelation",
    ProvideRelation_list:   "ProvideRelation_list", // Dropdown
    ProvideRelation_Address:"ProvideRelation_Address",
    ProvideRelation_PRN:    "ProvideRelation_PRN",

    SubscriptionServiceStartingDate: "Subscription Service Starting Date",
    SubscriptionServiceStartingDate_Day: "Subscription Service Starting Date DD",
    SubscriptionServiceStartingDate_Month: "Subscription Service Starting Date MM",
    SubscriptionServiceStartingDate_Year: "Subscription Service Starting Date YYYY",
    Address_of_Property:    "Address_of_Property",
    Address_of_Property_list: "Address_of_Property_list", // Dropdown
    Address_of_Property_Build:  "Address_of_Property_Build",
    Address_of_Property_Lot:    "Address_of_Property_Lot",

    Build_F:                "Build_F",
    Build_Flat:             "Build_Flat",
    Area_list:              "district_list", // Dropdown
    Area_HK:                "Area_HK",
    Area_KLN:               "Area_KLN",
    Area_NT:                "Area_NT",

    Lot_LotType:            "Lot_LotType",
    Lot_LotNo:              "Lot_LotNo",

    PRN:                    "PRN",
    AlterEmail:             "AlterEmail",
    AlterEmailCc:           "AlterEmailCc",
    AlterSMS:               "AlterSMS",
    EalertNotification:     "EalertNotification",
    EalertNotification_list: "EalertNotification_list", // Dropdown
    EalertNotification_Yes: "EalertNotification_Yes",
    EalertNotification_No:  "EalertNotification_No",

    Language:               "Language",
    Language_list:          "Language_list", // Dropdown
    Lang_Eng:               "Lang_Eng",
    Lang_Chn:               "Lang_Chn",

    SupportDocument:        "supportDocument",
    PeronsalIdDocAttach:    "PeronsalIdDocAttach", // Upload
    IdDocAttach:            "IdDocAttach", // Upload
    OtherIdDocAttach:       "OtherIdDocAttach", // Upload

    // Part5
    Questionnaire:                      "Questionnaire",
    Questionnaire_option_list:          "Questionnaire_option_list", // Dropdown
    Questionnaire_option_LRWeb:         "Questionnaire_option_LRWeb",
    Questionnaire_option_SolicitorFirm: "Questionnaire_option_SolicitorFirm",
    Questionnaire_option_LRInfo:        "Questionnaire_option_LRInfo",
    Questionnaire_option_PublicMaterial:"Questionnaire_option_PublicMaterial",
    Questionnaire_option_Friend:        "Questionnaire_option_Friend",
    Questionnaire_option_LRHotline:     "Questionnaire_option_LRHotline",
    Questionnaire_option_PressRelease:  "Questionnaire_option_PressRelease",
    Questionnaire_option_Other:         "Questionnaire_option_Other",
    Questionnaire_Other:                "Questionnaire_Other",

    Questionnaire_Option4_Options:      "Questionnaire_Option4_Options",
    Questionnaire_option4_option_list:  "Questionnaire_option4_option_list", // Dropdown
    Questionnaire_option4_option_Poster:"Questionnaire_option4_option_Poster",
    Questionnaire_option4_option_Leaflet:"Questionnaire_option4_option_Leaflet",
    Questionnaire_option4_option_TV:    "Questionnaire_option4_option_TV",
    Questionnaire_option4_option_Radio: "Questionnaire_option4_option_Radio",

    // AI
    AI_Address_of_Property_list:        "AI_Address_of_Property_list", // Dropdown
    AI_district_list:                   "AI_district_list", // Dropdown
};

export const RepresentativeIdTypeValueList = [
    {id: ID.RepresentativeIdType_HKID,    value: "RepresentativeIdDoc_Opt_1"},
    {id: ID.RepresentativeIdType_Other,   value: "RepresentativeIdDoc_Opt_2"},
];

export const SubscriberTypeValueList = [
    {id: ID.SubscriberType_New,    value: "New Applicant / 新申請人"},
    {id: ID.SubscriberType_Curr,   value: "Current Subscriber / 現有用戶"},
];

export const IdTypeValueList = [
    {id: ID.IdType_HKID,    value: "IdDoc_HKID_Strike"},
    {id: ID.IdType_CR,      value: "IdDoc_CR_Strike"},
    {id: ID.IdType_Other,   value: "IdDoc_Other_Strike"},
];

export const OwnerTypeValueList = [
    {id: ID.OwnerType_Individual,   value: "Individual"},
    {id: ID.OwnerType_Corporate,    value: "Corporate"},
];

export const SubscriptionFee0ValueList = [
    {id: ID.SubscriptionFee_OneOff,value: "New Application / New Order: One-off Subscription (HK$380)"},
    {id: ID.SubscriptionFee_New24, value: "24 months(HK$250) / 24 個月(港幣$250)"},
];

export const SubscriptionFeeValueList = [
    {id: ID.SubscriptionFee_OneOff, value: "New Application / New Order: One-off Subscription (HK$380)"},
    {id: ID.SubscriptionFee_New24,  value: "24 months(HK$250) / 24 個月(港幣$250)"},
    {id: ID.SubscriptionFee_Renew24,value: "24 months(HK$160) / 24 個月(港幣$160)"},
];

export const ProvideRelationValueList = [
    {id: ID.ProvideRelation_PRN,    value: "PRN"},
    {id: ID.ProvideRelation_Address,value: "Address"},
];

export const AddressOfPropertyValueList = [
    {id: ID.Address_of_Property_Build,  value: PropertyType.BUILD},
    {id: ID.Address_of_Property_Lot,    value: PropertyType.LOT},
];

export const AreaValueList = [
    {id: ID.Area_HK,                value: "HK"},
    {id: ID.Area_KLN,               value: "KLN"},
    {id: ID.Area_NT,                value: "NT"},
];

export const EalertNotificationValueList = [
    {id: ID.EalertNotification_Yes,  value: "Yes / 是"},
    {id: ID.EalertNotification_No,   value: "No / 否"},
];

export const LangValueList = [
    {id: ID.Lang_Eng,               value: "English / 英文"},
    {id: ID.Lang_Chn,               value: "Chinese / 中文"},
];

export const QuestionnaireOptionValueList = [
    {id: ID.Questionnaire_option_LRWeb,             value: "Questionnaire_Option1"},
    {id: ID.Questionnaire_option_SolicitorFirm,     value: "Questionnaire_Option2"},
    {id: ID.Questionnaire_option_LRInfo,            value: "Questionnaire_Option3"},
    {id: ID.Questionnaire_option_PublicMaterial,    value: "Questionnaire_Option4"},
    {id: ID.Questionnaire_option_Friend,            value: "Questionnaire_Option5"},
    {id: ID.Questionnaire_option_LRHotline,         value: "Questionnaire_Option6"},  
    {id: ID.Questionnaire_option_PressRelease,      value: "Questionnaire_Option7"},
    {id: ID.Questionnaire_option_Other,             value: "Questionnaire_Option8"},
];

export const QuestionnaireOption4ValueList = [
    {id: ID.Questionnaire_option4_option_Poster,            value: "Poster"},
    {id: ID.Questionnaire_option4_option_Leaflet,           value: "Leaflet"},
    {id: ID.Questionnaire_option4_option_TV,                value: "TV"},
    {id: ID.Questionnaire_option4_option_Radio,             value: "Radio"},
];


// Data Export
const SubscriberTypeForExport = {
    [ID.SubscriberType_New]     : "New Applicant",
    [ID.SubscriberType_Curr]    : "Current Subscriber",
};

const IdTypeForExport = {
    [ID.IdType_HKID]            : "HKID Card",
    [ID.IdType_CR]              : "Company Registration",
    [ID.IdType_Other]           : "Other Identification Document",
};

const OwnerTypeForExport = {
    [ID.OwnerType_Individual]   : "For individual owner",
    [ID.OwnerType_Corporate]    : "For corporate owner",
};

const FeeTypeForExport = {
    [ID.SubscriptionFee_OneOff]   : "NewOrderOneOff",
    [ID.SubscriptionFee_New24]    : "NewOrder24Months",
    [ID.SubscriptionFee_Renew24]  : "ServiceRenewal24Months",
};

const ProvideRelationForExport = {
    [ID.ProvideRelation_PRN]        : "PRN",
    [ID.ProvideRelation_Address]    : "Address",
};

const AddressOfPropertyForExport = {
    [ID.Address_of_Property_Build]  : "Build",
    [ID.Address_of_Property_Lot]    : "Lot",
};

const AreaForExport = {
    [ID.Area_HK]    : "H.K.",
    [ID.Area_KLN]   : "KLN",
    [ID.Area_NT]    : "N.T.",
};

const SMSForExport = {
    [ID.EalertNotification_Yes]  : "Yes",
    [ID.EalertNotification_No]   : "No",
};

const LanguageForExport = {
    [ID.Lang_Eng]   : "English",
    [ID.Lang_Chn]   : "Chinese",
};

const QuestionnaireOptionForExport = {
    [ID.Questionnaire_option_LRWeb]         : "Land Registry Website",
    [ID.Questionnaire_option_SolicitorFirm] : "Solicitors' Firm",
    [ID.Questionnaire_option_LRInfo]        : "Land Registry Information / Service Counter Staff",
    [ID.Questionnaire_option_PublicMaterial]: "Publicity Materials / Mass Media (Poster/Banner, Leaflet, TV, Radio",
    [ID.Questionnaire_option_Friend]        : "Friend / Relative",
    [ID.Questionnaire_option_LRHotline]     : "Land Registry Customer Service Hotline",  
    [ID.Questionnaire_option_PressRelease]  : "Press Release",
    [ID.Questionnaire_option_Other]         : "Others (Please specify)",
};

const QuestionnaireOption4ForExport = {
    [ID.Questionnaire_option4_option_Poster]    : "Poster",
    [ID.Questionnaire_option4_option_Leaflet]   : "Leaflet",
    [ID.Questionnaire_option4_option_TV]        : "TV",
    [ID.Questionnaire_option4_option_Radio]     : "Radio",
};

export const dataExportMapping = {
    [ID.SubscriberNameEng]      : {key: "subscriberNameEng",   getValue: (value) => value},
    [ID.SubscriberNameChi]      : {key: "subscriberNameChi",   getValue: (value) => value},
    [ID.SubscriberType]         : {key: "subscriberType",      getValue: (respectValue) => {
        const _target = SubscriberTypeValueList.find(item => item.value === respectValue);
        if(!_target) return "";
        return SubscriberTypeForExport[_target.id];
    }},
    [ID.AccountNo]              : {key: "accountNo",                getValue: (value) => value},
    [ID.IdDoc]                  : {key: "idType",                   getValue: (index) => {return IdTypeForExport[IdTypeValueList[index].id];}},
    [ID.IdNo]                   : {key: "idNo",                     getValue: (value) => value},
    [ID.SupportDocument]        : {key: "supportDocument",          getValue: (value) => value},
    [ID.OwnerType]              : {key: "ownerType",                getValue: (index) => {return OwnerTypeForExport[OwnerTypeValueList[index].id];}},
    [ID.OtherIdDoc]             : {key: "additionalProof",          getValue: (value) => value},
    [ID.AuthorizedName]         : {key: "fullNameDirector",         getValue: (value) => value},
    [ID.CorrAddress]            : {key: "address",                  getValue: (value) => value},
    [ID.ContactTel]             : {key: "phoneNo",                  getValue: (value) => value},
    [ID.ContactPerson]          : {key: "contactPerson",            getValue: (value) => value},
    [ID.EalertNotification]     : {key: "consolidateEmail",         getValue: (index) => {return SMSForExport[EalertNotificationValueList[index].id];}},
    [ID.Language]               : {key: "language",                 getValue: (index) => {return LanguageForExport[LangValueList[index].id];}},
    [ID.Questionnaire]          : {key: "sourceOfKnowledge",        getValue: (respectValue) => {
        const _target = QuestionnaireOptionValueList.find(item => item.value === respectValue);
        if(!_target) return "";
        return QuestionnaireOptionForExport[_target.id];
    }},
    [ID.Questionnaire_Option4_Options]      : {key: "sourceOfKnowledgePublicityMaterial",   getValue: (respectValue) => {
        const _target = QuestionnaireOption4ValueList.find(item => item.value === respectValue);
        if(!_target) return "";
        return QuestionnaireOption4ForExport[_target.id];
    }},
    [ID.Questionnaire_Other]    : {key: "sourceOfKnowledgeOther",   getValue: (value) => value},
}

export const orderInfosIDForExport = "orderInfos";

export const dataExportMainSheetMapping = {
    [ID.SubscriptionFee]        : {key: "subscriptionType",         getValue: (index) => {return FeeTypeForExport[SubscriptionFeeValueList[index].id];}},
    [ID.OrderNo]                : {key: "currentOrderNo",           getValue: (value) => value},
    [ID.VeriCode]               : {key: "verificationCode",         getValue: (value) => value},
    [ID.ProvideRelation]        : {key: "provideRelation",          getValue: (index) => {return ProvideRelationForExport[ProvideRelationValueList[index].id];}},
    [ID.Address_of_Property]    : {key: "addressOfProperty",        getValue: (index) => {return AddressOfPropertyForExport[AddressOfPropertyValueList[index].id];}},
    [ID.SubscriptionServiceStartingDate]    : {key: "subscriptionStartDt",      getValue: (value) => value},
    [SelectAddressInfo.BuildingFieldId]     : {key: "building",                 getValue: (value) => value},
    [SelectAddressInfo.StreetNameFieldId]   : {key: "street",                   getValue: (value) => value},
    [SelectAddressInfo.StreetNumberFieldId] : {key: "streetNumber",             getValue: (value) => value},
    [SelectAddressInfo.BlockFieldId]        : {key: "block",                    getValue: (value) => value},
    [ID.Build_F]                : {key: "floor",                                getValue: (value) => value},
    [ID.Build_Flat]             : {key: "flat",                                 getValue: (value) => value},
    [SelectAddressInfo.DistrictFieldId]     : {key: "district",                 getValue: (respectValue) => {
        const _target = AreaValueList.find(item => item.value === respectValue);
        if(!_target) return "";
        return AreaForExport[_target.id];
    }},
    [ID.Lot_LotType]            : {key: "lotType",                  getValue: (value) => value},
    [ID.Lot_LotNo]              : {key: "lotNo",                    getValue: (value) => value},
    [ID.PRN]                    : {key: "prn",                      getValue: (value) => value},
    [ID.AlterEmail]             : {key: "emailAddr",                getValue: (value) => value},
    [ID.AlterEmailCc]           : {key: "supplementaryEmail",       getValue: (value) => value},
    [ID.AlterSMS]               : {key: "sms",                      getValue: (value) => value},
}

export const dataExportSuppSheetMapping = (idx)=>  { return {
    ["AI_" + ID.SubscriptionFee + RECLIST_ID_SEP + idx]        : {key: "subscriptionType",          getValue: (index) => {return FeeTypeForExport[SubscriptionFeeValueList[index].id];}},
    ["AI_" + ID.OrderNo + RECLIST_ID_SEP + idx]                : {key: "currentOrderNo",            getValue: (value) => value},
    ["AI_" + ID.VeriCode + RECLIST_ID_SEP + idx]               : {key: "verificationCode",          getValue: (value) => value},
    ["AI_" + ID.ProvideRelation + RECLIST_ID_SEP + idx]        : {key: "provideRelation",           getValue: (index) => {return ProvideRelationForExport[ProvideRelationValueList[index].id];}},
    ["AI_" + ID.Address_of_Property + RECLIST_ID_SEP + idx]    : {key: "addressOfProperty",         getValue: (index) => {return AddressOfPropertyForExport[AddressOfPropertyValueList[index].id];}},
    ["AI_" + ID.SubscriptionServiceStartingDate + RECLIST_ID_SEP + idx]    : {key: "subscriptionStartDt",  getValue: (value) => value},
    [SuppSheet_SelectAddressInfo(idx).BuildingFieldId]         : {key: "building",                  getValue: (value) => value},
    [SuppSheet_SelectAddressInfo(idx).StreetNameFieldId]       : {key: "street",                    getValue: (value) => value},
    [SuppSheet_SelectAddressInfo(idx).StreetNumberFieldId]     : {key: "streetNumber",              getValue: (value) => value},
    [SuppSheet_SelectAddressInfo(idx).BlockFieldId]            : {key: "block",                     getValue: (value) => value},
    ["AI_" + ID.Build_F + RECLIST_ID_SEP + idx]                : {key: "floor",                     getValue: (value) => value},
    ["AI_" + ID.Build_Flat + RECLIST_ID_SEP + idx]             : {key: "flat",                      getValue: (value) => value},
    [SuppSheet_SelectAddressInfo(idx).DistrictFieldId]         : {key: "district",                  getValue: (respectValue) => {
        const _target = AreaValueList.find(item => item.value === respectValue);
        if(!_target) return "";
        return AreaForExport[_target.id];
    }},
    ["AI_" + ID.Lot_LotType + RECLIST_ID_SEP + idx]            : {key: "lotType",                   getValue: (value) => value},
    ["AI_" + ID.Lot_LotNo + RECLIST_ID_SEP + idx]              : {key: "lotNo",                     getValue: (value) => value},
    ["AI_" + ID.PRN + RECLIST_ID_SEP + idx]                    : {key: "prn",                       getValue: (value) => value},
    ["AI_" + ID.AlterEmail + RECLIST_ID_SEP + idx]             : {key: "emailAddr",                 getValue: (value) => value},
    ["AI_" + ID.AlterEmailCc + RECLIST_ID_SEP + idx]           : {key: "supplementaryEmail",        getValue: (value) => value},
    ["AI_" + ID.AlterSMS + RECLIST_ID_SEP + idx]               : {key: "sms",                       getValue: (value) => value},
}}